{
  "title": "如何管理平台超級管理員",
  "description": "授予或撤銷其他使用者的超級管理員（super admin）身分。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，該使用者立即取得或失去平台超級管理員權限，變更即時生效。",
  "roleNote": "平台超級管理員",
  "prerequisites": ["您本人具備超級管理員身分", "已知道目標使用者的帳號"],
  "pathLabel": "平台管理 → 管理員",
  "steps": [
    {
      "title": "1. 找到目標使用者",
      "description": "在「管理員」清單中搜尋或瀏覽使用者，確認其目前是否已是超級管理員。"
    },
    {
      "title": "2a. 授予超級管理員",
      "description": "對尚未擁有此身分的使用者點選「授予」；此操作具冪等性，若對方已是超級管理員，重複執行不會產生錯誤或重複紀錄。"
    },
    {
      "title": "2b. 撤銷超級管理員",
      "description": "對已擁有此身分的使用者點選「撤銷」；同樣具冪等性。系統會先檢查平台上是否仍會剩下至少一位啟用中的超級管理員，若這是最後一位，撤銷會被拒絕（409 錯誤），以避免平台失去所有超級管理員。"
    },
    {
      "title": "3. 確認結果",
      "description": "操作成功後畫面即時更新該使用者的角色徽章；若因「最後一位超級管理員保護」被拒絕，畫面會明確顯示原因，此時需先指定另一位超級管理員後才能撤銷原本這位。"
    }
  ],
  "afterward": [
    "目標使用者的超級管理員身分立即生效或失效",
    "該操作會被記錄於平台稽核紀錄",
    "若被保護機制拒絕，平台狀態不會有任何變更"
  ],
  "nextSteps": "授予後，建議提醒對方登入確認新權限已生效；撤銷後對方在下次操作時會立即失去相關管理入口。",
  "faq": [
    {
      "q": "為什麼我沒辦法撤銷某個人的超級管理員身分？",
      "a": "最常見的原因是「最後一位啟用中超級管理員保護」機制：系統不允許平台上一位啟用中的超級管理員都不剩，因此若目標使用者是目前唯一一位，撤銷請求會被拒絕（409 LAST_SUPER_ADMIN_PROTECTED）。請先授予另一位使用者超級管理員身分，再回頭撤銷原本這位。"
    },
    {
      "q": "重複點兩次「授予」會不會出錯或建立重複紀錄？",
      "a": "不會。授予與撤銷都是冪等操作 —— 對已是超級管理員的人再次授予、或對已非超級管理員的人再次撤銷，都只會回報「沒有變更」，不會產生錯誤或重複紀錄。"
    },
    {
      "q": "超級管理員和一般的「平台管理權限」有什麼不同？",
      "a": "超級管理員自動擁有平台上所有具名的管理權限（capability），不需要逐一勾選；一般管理員則是依實際被授予的個別權限（例如稽核紀錄讀取、帳號管理）決定能看到與操作哪些功能。"
    }
  ]
}
